export enum ConflictMenuType {
    AbilityMenu = 'AbilityMenu',
    AttackMenu = 'AttackMenu',
    InventoryMenu = 'InventoryMenu',
    PrimaryActionMenu = 'PrimaryActionMenu',
    HotkeyMenu = 'HotkeyMenu',
    ConflictCommandMenu = 'ConflictCommandMenu',
    ConflictMessageElement = 'ConflictMessageElement',
}
